'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainController = function MainController($http, $translate, tmhDynamicLocale) {
  'ngInject';
  // Preload meta for the next step

  _classCallCheck(this, MainController);

  $http.get('data/meta.json', { cache: true }).then(function (r) {
    return r.data;
  });
  // Change locale once
  tmhDynamicLocale.set($translate.use().slice(0, 2));
  // Get all links markup
  var links = angular.element('head link[type=\'text/css\']');
  // Current stylesheet
  var currentLink = links.filter('[title=\'index@' + $translate.use() + '\']');
  // Load the right stylesheet
  links.not(currentLink).prop('disabled', true);
  currentLink.prop('disabled', false);
};

angular.module('app').component('main', {
  templateUrl: 'app/main/main.html',
  controller: MainController
});